import { withAntComponent } from "../../hoc/withAntComponent";
import { Select as AntSelect } from "antd";
import styled from "styled-components";

const StyledAntSelect = styled(AntSelect)`
    &.ant-select {
        height: 40px;
        color: ${({
            theme: {
                colors: { secondary }
            }
        }) => secondary};

        &&.ant-select-focused:not(.ant-select-disabled).ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
            box-shadow: none;
            border-color: ${({
                theme: {
                    colors: { secondary }
                }
            }) => secondary};
        }

        &:hover {
            border-color: ${({
                theme: {
                    colors: { secondary }
                }
            }) => secondary};
        }

        .ant-select-selector {
            border-radius: 8px;
            border-color: ${({
                theme: {
                    colors: { primary }
                }
            }) => primary};
        }
    }

    &.ant-select-focused {
        border-color: ${({
            theme: {
                colors: { primary }
            }
        }) => primary};
        box-shadow: none;
        color: ${({
            theme: {
                colors: { primary }
            }
        }) => primary};
    }
`;

const Select = withAntComponent(StyledAntSelect);
export default Select;
